import script from "./KanbanView.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanView.vue?vue&type=script&setup=true&lang=js"

import "./KanbanView.vue?vue&type=style&index=0&id=4a55acb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a55acb2"]])

export default __exports__